import React, { Fragment, useEffect, useState } from "react";
import { Dialog, SecondaryButton } from "cdk-radial";
import { getSpecObj } from "../../../utils/spec-utils";
import { TestSimulatorContent } from "./TestSimulatorContent";
import { TEST_SIMULATOR_SUB_HEADER } from "../../api-directory-home/constants";
import "../test-simulator.css";

export const TestSimulator = ({ schema, endpoint, environmentURLs }) => {
  const [isTestSimDlgOpen, setIsTestSimDlgOpen] = useState(false);
  const [specContent, setSpecContent] = useState([]);
  const testSimulatorUrl=`${environmentURLs.DOCS_UI_URL}/docs/general/api-directory-marketplace/api-call-tester/`;
  useEffect(() => {
    if (!!schema?.paths) {
      const specObj = getSpecObj(schema);
      setSpecContent(specObj);
    }
  }, [schema]);

  const handleTestSimDlgOpen = (_) => {
    setIsTestSimDlgOpen(true);
  };

  const handleTestSimDlgClose = (_) => {
    setIsTestSimDlgOpen(false);
  };
  return (
    <Fragment>
      <SecondaryButton
        dataTestId="secondary-button"
        iconColor="primary"
        iconSize={24}
        onClick={() => handleTestSimDlgOpen()}
        size="standard"
        text="Try It Out"
      />
      <Dialog
        dataTestId="test-simil-dlg"
        id="test-simulator-dlg"
        isOpen={isTestSimDlgOpen}
        onClose={handleTestSimDlgClose}
        title="Try It Out"
        className="api-dir-pkg_test-simul-dlg"
      >
        <div className="api-dir-pkg_test-simul-sub-header">
          {TEST_SIMULATOR_SUB_HEADER + ' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={testSimulatorUrl}
          >
            <strong className="api-dir-pkg_learn-more-text">Learn More</strong>
          </a>
        </div>
        <TestSimulatorContent specContent={specContent} endpoint={endpoint} />
      </Dialog>
    </Fragment>
  );
};
